import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { CssBaseline,  Grid} from '@material-ui/core';

// import { useReactToPrint } from 'react-to-print';

import { DateRangePickerRayos } from './dateTimePicker/DateRangePickerRayos';
import { ReportPrintScreen } from './ReportPrintScreen';
import { useStyles } from './reportStyles';
import './css/reportPrint.css'
// import { htmlToCanvasImage } from '../../helpers/generalFunctions';




export const ReportRayosScreen = () => {

    const classes = useStyles();
    const {startDate:validation,namePoint} = useSelector(state => state.print)
    const [check, setCheck] = useState(false);

    const componentRef = useRef();


    /**
     * To print screen with jsPDF
     * @param {event} e 
     */
    



    // /**
    //  * Function that allow print the screen
    //  */
    // const handlePrint = useReactToPrint({
    //     content: () => componentRef.current,
    // });

    
    /**
     * Function that allows set the value of the check
     * @param {Event} event 
     */
   

    return (
        <>
            <CssBaseline />

            <main className={classes.content}>
                <div className={classes.appBarSpacer} />

                    <Grid container  className={classes.container} >

                        <Grid item xs={12} md={12} lg={12} className={classes.buttonCenter}>
                            <DateRangePickerRayos/>
                        </Grid>

                    </Grid>

                    <Grid 
                        container 
                        spacing={3} 
                        className={classes.container} 
                        ref={componentRef} 
                        id="PRINT" 
                        style={ check ? {display:'flex'}:{}}
                    >
                            <ReportPrintScreen/>
                    </Grid>

                    <Grid
                        container 
                        spacing={3} 
                        className={classes.container} 
                    >
                        
                    </Grid>


                   
            </main>
        </>
    )
}

